var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showLanguagesMessage()
      ? _c("div", { staticClass: "trp-controls-section" }, [
          _c(
            "div",
            {
              staticClass: "trp-controls-section-content",
              attrs: { id: "trp-translation-section" }
            },
            [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.editorStrings.extra_lang_row1)
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.editorStrings.extra_lang_row2)
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.editorStrings.extra_lang_row3)
                }
              })
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showUpsellMessage()
      ? _c("div", { staticClass: "trp-controls-section wp-core-ui" }, [
          _c(
            "div",
            {
              staticClass: "trp-controls-section-content",
              attrs: { id: "trp-upsell-section" }
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_title))]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row1))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row2))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row3))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row4))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row5))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row6))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.editorStrings.extra_upsell_row7))])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticStyle: { background: "#f5fb9d" } }, [
                  _vm._v(_vm._s(_vm.editorStrings.extra_upsell_row8))
                ])
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.editorStrings.extra_upsell_button)
                }
              })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }